import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CanActivateItemUnidade } from './can-activate-item-unidade';
import { ItemUnidadeComponent } from './item-unidade.component';
import { ItemUnidadeFormComponent } from './form';


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateItemUnidade],
                children: [
                    {path: '', component: ItemUnidadeComponent},
                    {path: 'novo', component: ItemUnidadeFormComponent},
                    {path: ':id', component: ItemUnidadeFormComponent}
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateItemUnidade
    ]
})
export class ItemUnidadeRoutingModule { }
